export const getVacancyShorthand = (shortString) => {
    if (shortString === 'op') return 'Onderwijzend personeel';
    if (shortString === 'oop') return 'Ondersteunend personeel';
    if (shortString === 'management') return 'Management';
};
